/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbox_ShowInputs */

const en_inbox_show = /** @type {(inputs: Inbox_ShowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show`)
};

const de_inbox_show = /** @type {(inputs: Inbox_ShowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansehen`)
};

/**
* | output |
* | --- |
* | "Show" |
*
* @param {Inbox_ShowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const inbox_show = /** @type {((inputs?: Inbox_ShowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_ShowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_inbox_show(inputs)
	return en_inbox_show(inputs)
});